import request from '@/utils/request'
import config from '@/config/env'
import { getStaticMapLocData, getStaticTotalSummary } from '@/utils/staticData'
import axios from 'axios'

/** 文档参考 /docs/大屏接口协议1.0.txt */

/**
 * 竞拍项目列表、挂牌项目列表
 */
export function getProjectList(data) {
    return request({
        baseURL: config.javaBase,
        url: 'bigScreen/summary/projectList',
        method: 'get',
        data
    })
}

/**
 * 获取倒计时开始结束时间
 */
export function auctionStartEndDate(data) {
    return request({
        baseURL: config.javaBase,
        url: '/auction/getInfoTime',
        method: 'get',
        data
    })
}

/**
 * 成交公告列表
 */
export function tranannouncements(data) {
    return request({
        baseURL: config.javaBase,
        url: 'bigScreen/summary/tranannouncements',
        method: 'get',
        data
    })
}

/**
 * 溢价率
 */
export function overPriceRate(data) {
    return request({
        baseURL: config.javaBase,
        url: 'bigScreen/summary/overPriceRate',
        method: 'get',
        data
    })
}
/**
 * 金融贷款
 */
export function mortgageSummary(data) {
    return request({
        baseURL: config.javaBase,
        url: 'bigScreen/summary/mortgageSummary',
        method: 'get',
        data
    })
}

/**
 * 获取 echart 相关信息
 */
export function getEchartInfo(data) {
    return request({
        baseURL: config.javaBase,
        url: 'api/screen/echart/area',
        method: 'post',
        data
    })
}
/**
 * 获取 echart 相关信息  站点地区列表
 */
export function siteLocList(data) {
    return request({
        baseURL: config.javaBase,
        url: 'bigScreen/summary/siteLocList',
        method: 'get',
        data
    })
}

/**
 * 累计总数统计
 */
export function getTotalSummary(data) {
    if (data.siteId) {
        return request({
            baseURL: config.javaBase,
            url: 'bigScreen/summary/totalSummary',
            method: 'get',
            data
        })
    } else {
        return getStaticTotalSummary()
    }
}

/**
 * 获取交易品种数据
 */
export function getCollectiveInfo(data) {
    return request({
        baseURL: config.javaBase,
        url: 'api/screen/collective',
        method: 'post',
        data
    })
}

/**
 * 各交易品种成交金额统计
 */
export function tradeAmountSummary(data) {
    return request({
        baseURL: config.javaBase,
        url: 'bigScreen/summary/tradeAmountSummary',
        method: 'get',
        data
    })
}
/**
 * 各交易品种成交面积统计
 */
export function largeScreenAreaStatistics(data) {
    return request({
        baseURL: config.javaBase,
        url: 'api/largeScreen/largeScreenAreaStatistics',
        method: 'get',
        data
    })
}
/**
 * 各交易品种成交项目统计
 */
export function largeScreenItemStatistics(data) {
    return request({
        baseURL: config.javaBase,
        url: 'api/largeScreen/largeScreenItemStatistics',
        method: 'get',
        data
    })
}
/**
 * 按站点统计农业数据
 */

export function agriculturalSummary(data) {
    return request({
        baseURL: config.javaBase,
        url: 'bigScreen/summary/agriculturalSummary',
        method: 'get',
        data
    })
}
/**
 * 竞拍项目详情
 */
export function auctionInfo(data) {
    return request({
        baseURL: config.javaBase,
        url: 'CMSAuction/info',
        method: 'get',
        data
    })
}
/**
 * 竞拍项目出价记录
 */
export function biddingRecord(data) {
    return request({
        baseURL: config.javaBase,
        url: 'auctionUser/biddingRecord',
        method: 'get',
        data
    })
}
/**
 * 首页模块排序
 */
export function queryBigScreenModuleSiteList(data) {
    return request({
        baseURL: config.javaBase,
        url: 'api/bigScreen/moduleSite/queryBigScreenModuleSiteList',
        method: 'get',
        data
    })
}
/**
 * 获取高标农田数据
 */
export function queryFarmlandData(data) {
    return request({
        baseURL: config.javaBase,
        url: 'bigScreen/summary/getFarmlandData',
        method: 'get',
        data
    })
}
/**
 * 获取地图浮动地区数据
 */
export function getMapLocData(data) {
    if (data.siteId) {
        return request({
            baseURL: config.javaBase,
            url: 'bigScreen/summary/mapLocData',
            method: 'get',
            data
        })
    } else {
        return getStaticMapLocData(data.summaryType)
    }
}
/**
 * 获取地图 JSON 数据
 * @param {string} name 地图名称，参见 /public/map-json 地图
 */
export function getMapJSON(name) {
    return axios({
        baseURL: '/map-json',
        url: `${name}.json`,
        method: 'get'
    })
}
